(() => {
  const ZIP_API = 'https://api.zippopotam.us/us/';
  const CACHE_KEY = 'tango-zip-cache-v1';
  const MAX_RESULTS = 10;

  function readCache() {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  const zipCache = readCache();
  const pending = {};

  function geocodeZip(zip) {
    const clean = String(zip || '').trim().slice(0, 5);
    if (!/^\d{5}$/.test(clean)) return Promise.resolve(null);
    if (zipCache[clean]) return Promise.resolve(zipCache[clean]);
    if (pending[clean]) return pending[clean];
    pending[clean] = fetch(ZIP_API + clean)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        const place = data && data.places && data.places[0];
        if (!place) return null;
        const coords = { lat: parseFloat(place.latitude), lng: parseFloat(place.longitude) };
        zipCache[clean] = coords;
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(zipCache));
        } catch (e) {
          /* storage full or blocked */
        }
        return coords;
      })
      .catch(() => null);
    return pending[clean];
  }

  function milesBetween(a, b) {
    const toRad = (d) => (d * Math.PI) / 180;
    const R = 3958.8;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const h =
      Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function mapUrl(query, zoom) {
    return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=${zoom}&output=embed`;
  }

  function initLocator(root) {
    if (root.dataset.locatorReady) return;
    root.dataset.locatorReady = 'true';

    const mapEl = root.querySelector('[data-locator-map]');
    const form = root.querySelector('[data-locator-form]');
    const input = root.querySelector('[data-locator-input]');
    const geoBtn = root.querySelector('[data-locator-geo]');
    const status = root.querySelector('[data-locator-status]');
    const list = root.querySelector('[data-locator-list]');
    const storeEls = Array.from(root.querySelectorAll('[data-locator-store]'));
    const storeZoom = (mapEl && parseInt(mapEl.dataset.storeZoom, 10)) || 15;

    const stores = storeEls.map((el) => {
      const lat = parseFloat(el.dataset.lat);
      const lng = parseFloat(el.dataset.lng);
      return {
        el,
        zip: el.dataset.zip,
        query: el.dataset.query || el.dataset.name,
        exact: !isNaN(lat) && !isNaN(lng) ? { lat, lng } : null,
        coords: null,
      };
    });
    let activeStore = null;

    function setActive(store) {
      if (activeStore) activeStore.el.classList.remove('is-active');
      activeStore = store;
      store.el.classList.add('is-active');
      if (mapEl) {
        const q = store.exact ? `${store.exact.lat},${store.exact.lng}` : store.query;
        mapEl.src = mapUrl(q, storeZoom);
      }
    }

    stores.forEach((store) => {
      const btn = store.el.querySelector('[data-locator-focus]');
      if (btn) btn.addEventListener('click', () => setActive(store));
    });

    async function locateStores() {
      await Promise.all(
        stores.map(async (store) => {
          if (!store.coords) store.coords = store.exact || (await geocodeZip(store.zip));
        })
      );
    }

    async function showResults(origin) {
      await locateStores();
      const located = stores.filter((s) => s.coords);
      located.forEach((s) => (s.distance = milesBetween(origin, s.coords)));
      const sorted = located.sort((a, b) => a.distance - b.distance);
      const unlocated = stores.filter((s) => !s.coords);

      sorted.concat(unlocated).forEach((s, i) => {
        list.appendChild(s.el);
        s.el.hidden = i >= MAX_RESULTS;
        const distEl = s.el.querySelector('[data-locator-distance]');
        if (distEl) distEl.textContent = s.coords ? `${s.distance < 10 ? s.distance.toFixed(1) : Math.round(s.distance)} mi` : '';
      });
      list.scrollTop = 0;

      const count = Math.min(sorted.length, MAX_RESULTS);
      status.textContent = (status.dataset.msgResults || '').replace('[count]', count);
      if (sorted[0]) setActive(sorted[0]);
    }

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const zip = input.value.trim();
        if (!/^\d{5}$/.test(zip)) {
          status.textContent = status.dataset.msgInvalid || '';
          input.focus();
          return;
        }
        const origin = await geocodeZip(zip);
        if (!origin) {
          status.textContent = status.dataset.msgNotfound || '';
          return;
        }
        showResults(origin);
      });
    }

    if (geoBtn) {
      geoBtn.addEventListener('click', () => {
        if (!navigator.geolocation) {
          status.textContent = status.dataset.msgGeoError || '';
          return;
        }
        navigator.geolocation.getCurrentPosition(
          (pos) => showResults({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
          () => (status.textContent = status.dataset.msgGeoError || ''),
          { timeout: 10000 }
        );
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-tango-locator]').forEach(initLocator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
